export default {
  getRecordList: '/api/record/alarm/list',
  getRecordDetail: '/api/record/detail',
  saveOrUpdateSummary: '/api/record/saveOrUpdateSummary',
  queryTheAlarmInformation: '/api/record/todo/list',
  queryEventAlertsNeedToBeHandledCount: '/api/record/todo/count',
  queryHaveToDealWithCount: '/api/record/finish/count',
}
